import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApiService } from '../app/services/api.service';

@Component({
  selector: 'app-users-sync',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './users-sync.component.html',
  styleUrls: ['./users-sync.component.scss']
})
export class UsersSyncComponent implements OnInit {
  loading = false;
  result: any = null;
  errorMessage = '';
  showSyncButton = false;

  constructor(private api: ApiService) {}

  ngOnInit(): void {
    this.checkUserAccess();
  }

  private checkUserAccess() {
    const userData = JSON.parse(localStorage.getItem('userData') || '{}');
    const roles: string[] = (userData?.role_names || '').split(',').map((r:string) => r.trim());
    this.showSyncButton = roles.includes('admin');
    console.log("this.showSyncButton",this.showSyncButton);
  }

  syncUsers(): void {
    if (!this.showSyncButton) return;
    this.loading = true;
    this.result = null;
    this.errorMessage = '';

    // Build request headers dynamically
    const user = JSON.parse(localStorage.getItem('userData') || '{}');
    const userToken = user?.token || '';
    const appId = '7';
    const cityId = '13';

    const headers = {
      'user-token': userToken || '',
      'app-id': appId,
      'city-id': cityId,
      'Content-Type': 'application/json',
    };

    // Call backend API through ApiService
    this.api.post<any>('/users/sync-users', { }, { headers }).subscribe({
      next: (res) => {
        this.loading = false;
        this.result = res;
        // setTimeout(() => (this.result = null), 6000); // auto-hide after 6s
      },
      error: (err) => {
        this.loading = false;
        this.errorMessage = err?.error?.message || 'Sync failed. Please try again.';
        // setTimeout(() => (this.errorMessage = ''), 6000);
      },
    });
  }
}
